import { CanMatchFn } from '@angular/router';

import { PREVIEW } from '../preview/preview-mode';

/**
 * The only screens the admin live preview shows — it is read-only. Orders and Account are there so
 * the admin sees the full phone tab bar; inside the preview they always render as a guest
 * (Account → guest view, Orders → empty history). The desktop header doesn't link to them there.
 */
export const PREVIEW_SCREENS = ['home', 'menu', 'orders', 'account'];

/**
 * Put on every route except PREVIEW_SCREENS. In the admin live preview it
 * refuses the match, so navigation falls through to the `**` → home redirect:
 * no sign-in, cart, checkout, orders or account screens inside the admin.
 * Outside the preview it always matches.
 */
export const notInPreviewGuard: CanMatchFn = () => !PREVIEW.active;
